import ReactDataTables from "./ReactDataTables";

export default ReactDataTables;
